/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInstantConversationRequest
 */
export interface CreateInstantConversationRequest {
    /**
     * The identityId of the client
     * @type {string}
     * @memberof CreateInstantConversationRequest
     */
    clientIdentityId: string;
    /**
     * The accountId of the freelancer
     * @type {string}
     * @memberof CreateInstantConversationRequest
     */
    freelancerAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInstantConversationRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInstantConversationRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInstantConversationRequest
     */
    searchEventId?: string;
}

/**
 * Check if a given object implements the CreateInstantConversationRequest interface.
 */
export function instanceOfCreateInstantConversationRequest(value: object): value is CreateInstantConversationRequest {
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    if (!('freelancerAccountId' in value) || value['freelancerAccountId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function CreateInstantConversationRequestFromJSON(json: any): CreateInstantConversationRequest {
    return CreateInstantConversationRequestFromJSONTyped(json, false);
}

export function CreateInstantConversationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInstantConversationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientIdentityId': json['clientIdentityId'],
        'freelancerAccountId': json['freelancerAccountId'],
        'content': json['content'],
        'subject': json['subject'],
        'searchEventId': json['searchEventId'] == null ? undefined : json['searchEventId'],
    };
}

export function CreateInstantConversationRequestToJSON(value?: CreateInstantConversationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientIdentityId': value['clientIdentityId'],
        'freelancerAccountId': value['freelancerAccountId'],
        'content': value['content'],
        'subject': value['subject'],
        'searchEventId': value['searchEventId'],
    };
}

